import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const Title = ({ title, imagePath }) => {
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const location = useLocation();

    const updateScreenSize = () => setIsSmallScreen(window.innerWidth <= 1100);

    useEffect(() => {
        updateScreenSize();
        window.addEventListener("resize", updateScreenSize);
        return () => window.removeEventListener("resize", updateScreenSize);
    }, []);

    useEffect(() => {
        setShowImage(false);
        const timer = setTimeout(() => setShowImage(true), 100);
        return () => clearTimeout(timer);
    }, [location.pathname]);

    const getFontSize = () => {
        if (window.innerWidth <= 360) return "18px";
        if (window.innerWidth <= 480) return "22px";
        if (window.innerWidth <= 768) return "28px";
        if (window.innerWidth <= 1024) return "36px";
        return "50px";
    };

    return (
        <div
            style={{
                position: "relative",
                width: "100vw",
                marginLeft: "calc(-50vw + 50%)",
                overflow: "hidden",
                backgroundColor: "black",
            }}
        >
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    height: isSmallScreen ? "300px" : "450px",
                }}
            >
                {/* Background image */}
                <img
                    src={imagePath}
                    alt={title}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        transition: "opacity 0.8s ease-in-out",
                        opacity: showImage ? 1 : 0,
                        display: "block",
                    }}
                />

                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center", // centers vertically
                        justifyContent: "center", // centers horizontally
                        textAlign: "center",
                        padding: "0 1rem",
                    }}
                >
                    <h1
                        style={{
                            color: "white",
                            fontWeight: 600,
                            fontSize: getFontSize(),
                            lineHeight: "1.2em",
                            textShadow: "0 2px 10px rgba(0,0,0,0.6)",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            maxWidth: "700px",
                            margin: 0,
                        }}
                    >
                        {title}
                    </h1>
                </div>
            </div>
        </div>
    );
};

export default Title;
